var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { COLORS } from "../../../constants";
/**
 * styles for Mui alert
 */
export var alertStylesFn = function (_a) {
    var displayAsColumn = _a.displayAsColumn, theme = _a.theme, iconFlexAlign = _a.iconFlexAlign, _b = _a.sx, sx = _b === void 0 ? {} : _b;
    return (__assign(__assign(__assign({ "&.MuiAlert-standardSuccess, &.MuiAlert-standardError, &.MuiAlert-standardWarning, &.MuiAlert-standardInfo": {
            background: theme === "dark" ? COLORS.SHADED_GREY : COLORS.WHITE,
            pl: 3,
            pr: displayAsColumn ? 2.5 : 4,
        }, ".MuiAlert-icon": {
            alignSelf: iconFlexAlign,
            mt: iconFlexAlign === "flex-start" ? 1.75 : 0,
        }, ".MuiAlert-message": __assign({ py: 2.5 }, (displayAsColumn
            ? {
                width: "calc(100% - 38px)",
                display: "flex",
                alignItems: "flex-start",
            }
            : {})), ".MuiAlert-action": {
            alignItems: "center",
            pr: displayAsColumn ? 1 : 0,
            flexShrink: 0,
        }, pt: 0.5, pb: displayAsColumn ? 3 : 0.5, minHeight: 72, alignItems: "center" }, (displayAsColumn
        ? {
            flexWrap: "wrap",
        }
        : {})), { width: displayAsColumn ? 344 : 488 }), sx));
};
